import { render } from "./Main.vue?vue&type=template&id=5a6fadce&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=5a6fadce&lang=less&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=5a6fadce&lang=less"
script.render = render
script.__scopeId = "data-v-5a6fadce"

export default script